import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import LoadingProgress from "../components/LoadingProgress";
import ErrorMessage from "../components/ErrorMessage";
import DuplicatedSaleList from "../components/DuplicatedSaleList";
import DuplicatedSalesFilterForm from "../forms/DuplicatedSalesFilterForm";

import "../styles/DuplicatedSalesView.css";

import { fetchDuplicatedSales } from "../actions/duplicatedsales";
import { fetchMachines } from "../actions/machines";

// Cliente interno VACWAY TECH: sus ventas son de prueba y ensucian el análisis, así que por
// defecto se ocultan (mismo id que usa SalesView).
const EXCLUDE_CUSTOMER_ID = "620d1664db950220fabc0a41";

// Ventas cuyo Code chocó con uno ya existente (normalmente porque el kiosco perdió su contador
// LastSale y volvió a 000001). Antes se descartaban en silencio; ahora el lambda las guarda en
// `duplicated-sales` y esta vista (solo admin) permite revisarlas.
class DuplicatedSalesView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showFilters: true, excludeVacway: true };
    this.toggleFilters = this.toggleFilters.bind(this);
    this.toggleExcludeVacway = this.toggleExcludeVacway.bind(this);
  }

  componentDidMount() {
    // Rango por defecto: últimos 7 días, filtrado por fecha de detección (igual que el
    // initialValues del formulario, para que fechas y datos coincidan al abrir la vista).
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 7);

    const startStr = start.toISOString().substring(0, 10);
    const endStr = end.toISOString().substring(0, 10);

    this.props.fetchDuplicatedSales("", "", startStr, endStr, "detectedAt", "");
    this.props.fetchMachines();
  }

  toggleFilters() {
    this.setState((s) => ({ showFilters: !s.showFilters }));
  }

  toggleExcludeVacway() {
    this.setState((s) => ({ excludeVacway: !s.excludeVacway }));
  }

  // Lista que realmente se muestra: aplica el filtro "Ocultar VACWAY" sobre lo que trae el store.
  getDisplaySales() {
    const list = this.props.duplicatedSales || [];
    if (this.state.excludeVacway) {
      return list.filter((s) => !(s.Customer && s.Customer._id === EXCLUDE_CUSTOMER_ID));
    }
    return list;
  }

  renderKpis(list) {
    const lost = list.filter((s) => s.SameAsOriginal === false);
    const replicas = list.filter((s) => s.SameAsOriginal === true);
    const lostAmount = lost.reduce((acc, s) => acc + (parseFloat(s.Amount) || 0), 0);

    return (
      <div className="duplicated-sales-kpi-row">
        <div className="duplicated-kpi-card lost">
          <div className="kpi-icon"><i className="fas fa-exclamation-triangle"></i></div>
          <div className="kpi-content">
            <div className="kpi-label">Ventas perdidas</div>
            <div className="kpi-value">{lost.length}</div>
          </div>
        </div>
        <div className="duplicated-kpi-card amount">
          <div className="kpi-icon"><i className="fas fa-euro-sign"></i></div>
          <div className="kpi-content">
            <div className="kpi-label">Importe perdido</div>
            <div className="kpi-value">
              {lostAmount.toLocaleString("es-ES", { style: "currency", currency: "EUR" })}
            </div>
          </div>
        </div>
        <div className="duplicated-kpi-card replica">
          <div className="kpi-icon"><i className="fas fa-clone"></i></div>
          <div className="kpi-content">
            <div className="kpi-label">Réplicas (reintentos)</div>
            <div className="kpi-value">{replicas.length}</div>
          </div>
        </div>
      </div>
    );
  }

  renderList() {
    const { error, loading, duplicatedSales } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!duplicatedSales || loading) {
      return <LoadingProgress />;
    }

    const displayed = this.getDisplaySales();

    return (
      <div>
        {this.renderKpis(displayed)}
        <div className="duplicated-sales-table-card">
          <div className="card-title-bar">
            <i className="fas fa-list"></i>
            Listado ({displayed.length}) · 100 por página
          </div>
          <DuplicatedSaleList sales={displayed} />
        </div>
      </div>
    );
  }

  render() {
    const { showFilters, excludeVacway } = this.state;

    return (
      <div className="duplicated-sales-view">
        <div className="duplicated-sales-header">
          <div className="header-content">
            <div className="header-text">
              <h1><i className="fas fa-clone mr-2"></i>Ventas Duplicadas</h1>
              <p>
                Ventas cuyo número de factura (Code) chocó con uno ya existente, normalmente
                porque un kiosco perdió su contador y reinició la numeración. Las{" "}
                <strong>ventas perdidas</strong> son ventas reales que antes se descartaban; las{" "}
                <strong>réplicas</strong> son reintentos de red inofensivos.
              </p>
            </div>
          </div>
          <div className="header-actions">
            <label className="dup-switch-wrap" title="Ocultar las ventas de prueba de VACWAY TECH">
              <span className="dup-switch-text">Ocultar VACWAY</span>
              <span className="dup-switch">
                <input type="checkbox" checked={excludeVacway} onChange={this.toggleExcludeVacway} />
                <span className="dup-switch-slider"></span>
              </span>
            </label>
            <button
              className={`dup-filter-toggle ${showFilters ? 'is-active' : ''}`}
              onClick={this.toggleFilters}
            >
              <i className="fas fa-sliders-h"></i>
              {showFilters ? 'Ocultar filtros' : 'Mostrar filtros'}
              <i className={`fas fa-chevron-${showFilters ? 'up' : 'down'}`}></i>
            </button>
          </div>
        </div>

        {showFilters && (
          <div className="duplicated-sales-filter">
            <DuplicatedSalesFilterForm />
          </div>
        )}

        {this.renderList()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  duplicatedSales: state.duplicatedSales.duplicatedSales,
  error: state.duplicatedSales.error,
  loading: state.duplicatedSales.loading,
  auth: state.auth,
  role: state.auth.role,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDuplicatedSales: bindActionCreators(fetchDuplicatedSales, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DuplicatedSalesView);
